import "../assets/css/comm.css";

export const getCurrentTimestamp = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.0`;
};

export const getDateFormat = (format = 'yyyy-mm-dd', addYear = 0, addMonth = 0, addDay = 0) => {
    const now = new Date();

    // 날짜 조정
    now.setFullYear(now.getFullYear() + addYear);
    now.setMonth(now.getMonth() + addMonth);
    now.setDate(now.getDate() + addDay);

    const year = String(now.getFullYear());
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    // 단일 항목 요청
    switch (format.toLowerCase()) {
        case 'yyyy': return year;
        case 'mm': return month;
        case 'dd': return day;
        case 'hh': return hours;
        case 'mi': return minutes;
        case 'ss': return seconds;
    }

    // 포맷 전체 반환
    if (format === 'yyyymmdd') {
        return `${year}${month}${day}`;
    }

    if (format === 'yyyy-mm-dd') {
        return `${year}-${month}-${day}`;
    }

    // 잘못된 포맷일 경우 기본값 반환
    return `${year}-${month}-${day}`;
};

export const timeOutAlert = ({ header, body, timeOut } = {}) => {
    return new Promise((resolve) => {

        const style = document.createElement("style");
        style.innerHTML = `
            .fade-target {
                opacity: 1;
                transition: opacity 0.5s ease;
            }
            .fade-target.fade-out {
                opacity: 0;
            }
        `;
        document.head.appendChild(style);

        const wrapper = window.document.createElement("div");
        wrapper.classList.add("m-modal-root");
        wrapper.innerHTML = `
                <div class="m-modal m-messageBox visible fade-target">
                    <div class="m-modal-bg">
                        <div class="m-modal-box">
                            <div class='m-modal-container-alert'>
                                <div class="m-modal-title">
                                    <h3>${header ?? "알림"}</h3>
                                </div>
                                <div class="m-modal-content">
                                    ${body ?? ""}
                                    <div style="height: 16px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>      
            `;
        
        window.document.body.appendChild(wrapper);

        const fadeTarget = wrapper.querySelector(".fade-target");
        const duration = typeof timeOut === "number" && timeOut > 0 ? timeOut * 1000 : 3000;
    
        // 애니메이션 적용
        setTimeout(() => {
            if (!fadeTarget) return;
            fadeTarget.classList.add("fade-out");
        
            setTimeout(() => {
                wrapper.remove();
                resolve(true);
            }, 500); // 페이드아웃 시간과 일치시킴
        }, duration);
    });
};
export const alert = ({ header, body } = {}) => {
    return new Promise((resolve) => {
        const wrapper = window.document.createElement("div");
        wrapper.classList.add("m-modal-root");
        wrapper.innerHTML = `
                <div class="m-modal m-messageBox" visible>
                    <div class="m-modal-bg">
                        <div class="m-modal-box">
                            <div class='m-modal-container-alert'>
                                <div class="m-modal-title">
                                    <h3>${header ?? "알림"}</h3>
                                </div>
                                <div class="m-modal-content">
                                    ${body ?? ""}
                                </div>
                                    <div class="m-modal-buttons">
                                    <a class="btn-bg confirmBtn">
                                        <span class="confirmBtn">확인</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>      
            `;
        wrapper.addEventListener("click", (e) => {
        if (e.target.classList.contains("confirmBtn")) {
            resolve(true);
            wrapper.remove();
        }
        });
        window.document.body.appendChild(wrapper);
    });
};

export const confirm = ({ header, body } = {}) => {
    return new Promise((resolve) => {
        const wrapper = window.document.createElement("div");
        wrapper.classList.add("m-modal-root");
        wrapper.innerHTML = `
                <div class="m-modal m-messageBox" visible>
                    <div class="m-modal-bg">
                        <div class="m-modal-box">
                            <div class='m-modal-container-alert'>
                                <div class="m-modal-title">
                                    <h3>${header ?? "알림"}</h3>
                                </div>
                                <div class="m-modal-content">
                                    ${body ?? ""}
                                </div>
                                    <div class="m-modal-buttons">
                                    <a class="btn-bg confirmBtn">
                                        <span class="confirmBtn">확인</span>
                                    </a>
                                    <a class="btn closeBtn">
                                        <span class='closeBtn'>취소</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>             
            `;
        wrapper.addEventListener("click", (e) => {
        if (e.target.classList.contains("closeBtn")) {
            resolve(false);
            wrapper.remove();
        }
        if (e.target.classList.contains("confirmBtn")) {
            resolve(true);
            wrapper.remove();
        }
        });
        window.document.body.appendChild(wrapper);
    });
};